import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Welcome from "./components/Welcome";
import Chatbot from "./components/Chatbot";
import ImageGen from './components/ImageGen'
import Speech from "./components/Speech";

function App() {
  return (
    <>
      <Router>
        <div className="container">
          <Routes>
            <Route exact path="/" element={<Welcome />} />
            <Route exact path="/chatRoulette" element={<Chatbot />} />
            <Route exact path="/image-generation" element={<ImageGen />} />
            <Route exact path="/speech" element={<Speech/>} />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
